import {EventEmitter, Injectable} from '@angular/core';
import {CommonConstant} from '../../app.constants';

@Injectable()
export class PlaceholderVisibilityService {

  public triggerPlaceholder$: EventEmitter<any>;

  constructor() {
    this.triggerPlaceholder$ = new EventEmitter<string>();
  }

  public show(placeholderId: string): void {
    this.triggerPlaceholder$.emit({id: placeholderId, action: CommonConstant.SHOW_PLACEHOLDER});
  }

  public hide(placeholderId: string, deplay = 200): void {
    // deplay for rendering
    setTimeout(() => {
      this.triggerPlaceholder$.emit({id: placeholderId, action: CommonConstant.HIDE_PLACEHOLDER});
    }, deplay);
  }

  public hideImmediately(placeholderId: string) {
    this.triggerPlaceholder$.emit({id: placeholderId, action: CommonConstant.HIDE_PLACEHOLDER});
  }

}



// WEBPACK FOOTER //
// ./src/app/services/placeholder-visibility/placeholder-visibility.service.ts